.link {
    align-items: center;
    color: var(--color-lobster);
    display: flex;
    margin: 0.25rem 0;
    text-decoration: none;
    text-transform: uppercase;

    &::before {
        background-color: var(--color-lobster);
        content: "";
        display: inline-block;
        height: 14px;
        margin-right: 0.25rem;
        mask-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 448 512'%3E%3C!--! Font Awesome Free 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --%3E%3Cpath d='M429.6 92.1c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8H224V432c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352z'/%3E%3C/svg%3E");
        mask-position: center;
        mask-repeat: no-repeat;
        mask-size: 14px 14px;
        min-width: 14px;
    }

    &:hover {
        color: var(--color-black);

        &::before {
            background-color: var(--color-black);
        }
    }
}
